export const publishedCheckoutNameQueryParam = 'publishedCheckoutName';
